<div class="row">
    <div class="col-md-12">
        <div class="card card-user mb-3 full-dashboard-bgcover">
            <div class="card-header bluebg-heading">
                <div class="d-flex justify-content-between">
                    <h4 class="m-0">{{QuestionConstant.VIEW_QUESTION}}</h4>
                </div>
            </div>
            <div class="card-body justify-content-start">
                <form [formGroup]="questionEditForm" #questionForm="ngForm" novalidate>
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <div class="form-group mb-4 matselectfield">
                                <label>{{QuestionConstant.TYPE_OF_QUESTION}}<span class="form-control-danger">*</span>
                                </label>
                                <select
                                    class="form-control ng-untouched ng-pristine form-select ng-valid form-control-lg"
                                    formControlName="questionTypeId" (change)="onQuestionTypeChange()">
                                    <option value="">-- Select Question Type --</option>
                                    <ng-container *ngFor="let questionType of questionTypeList">
                                        <option [value]="questionType.id">{{questionType.value}}</option>
                                    </ng-container>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <div class="form-group mb-4 matselectfield">
                                <label>{{QuestionConstant.QUESTION_SET}}<span class="form-control-danger">*</span>
                                </label>
                                <select id="style"
                                    class="form-control ng-untouched ng-pristine form-select ng-valid form-control-lg"
                                    formControlName="questionSetId">
                                    <option value="">-- Select Question Set --</option>
                                    <ng-container *ngFor="let questionSet of questionSetList">
                                        <option [value]="questionSet.id">{{questionSet.value}}</option>
                                    </ng-container>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="!showParagraphText">
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group mb-4">
                                <label>{{QuestionConstant.QUESTION}}<span class="form-control-danger">*</span></label>
                                <textarea type="text" class="form-control
                                form-control-lg" required autocomplete="off" formControlName="questionText"
                                    placeholder="Enter Question" (keydown)="CommonService.space($event)"></textarea>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12" *ngIf="showParagraphText">
                            <div class="form-group mb-4">
                                <label>{{QuestionConstant.PARAGRAPH_TEXT}} <span
                                        class="form-control-danger">*</span></label>
                                <textarea type="text" class="form-control
                                form-control-lg" required autocomplete="off" formControlName="paragraphText"
                                    placeholder="Enter Paragraph Text" (keydown)="CommonService.space($event)"
                                    [ngClass]="{'form-control-danger': questionForm.submitted && questionFormControl['paragraphText'].errors?.['required']}"></textarea>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12" *ngIf="showImage">
                            <div class="form-group mb-4">
                                <label>{{QuestionConstant.IMAGE}} <span class="form-control-danger">*</span></label>
                                <div class="uploadbtn-wrap">
                                    <div class="uploadbtn w-100" id="fileInput">
                                        <img [src]="imageURL ? imageURL : 'assets/img/upload-icon.png'" accept="image/*"
                                            class="img-fluid mb-3" alt="image">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="QuestionTypeId>0 && !showParagraphText">
                        <div class="col-xl-7 col-lg-8 col-md-12">
                            <div formArrayName="questionOptions">
                                <div class="create-box mb-3">
                                    <div class="row mb-4 align-items-center"
                                        *ngFor="let option of questionOptions?.controls; let i = index"
                                        [formGroupName]="i">
                                        <div class="col-sm-1 col-2">
                                            <div class="form-group">
                                                <label></label>
                                            </div>
                                            <div class="form-group">
                                                <div class="form-check" *ngIf="showMultiSelect">
                                                    <input formControlName="isCorrectAnswer"
                                                        class="form-check-input checkbox-square" type="checkbox"
                                                        name="radAnswer + i" id="{{ 'flexRadioDefault2' + i }}">
                                                </div>
                                                <div class="form-check" *ngIf="showRadio">
                                                    <input formControlName="isCorrectAnswer"
                                                        class="form-check-input checkbox-round" type="checkbox"
                                                        name="radAnswer" value="" id="{{ 'flexRadioDefault1' + i }}">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-9 col-sm-11 col-10">
                                            <div class="form-group">
                                                <label>Option {{i+1}}<span class="form-control-danger">*</span></label>
                                            </div>
                                            <div class="form-group position-relative">
                                                <input formControlName="optionText" type="text" class="form-control"
                                                    (keydown)="CommonService.space($event)" required />
                                            </div>
                                        </div>
                                        <div class="row text-center" *ngIf="CheckCorrect(i)">
                                            <div class="col-sm-2 col-2">
                                            </div>
                                            <div class="col-sm-7 col-7" style="color: green; margin-top: 1%;">
                                                Correct answer
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="showParagraphText">
                        <div class="col-12">
                            <div class="form-group">
                                <label>{{QuestionConstant.PARAGRAPH_TEXT}} <span
                                        class="form-control-danger">*</span></label>
                                <textarea type="text" class="form-control" required autocomplete="off"
                                    formControlName="paragraphText" placeholder="Enter ParagraphText" rows="10"
                                    (keydown)="CommonService.space($event)"
                                    [ngClass]="{'form-control-danger': questionForm.submitted && questionFormControl['paragraphText'].errors?.['required']}"
                                    oninput="this.value = this.value.replace(/^\s+/g, '')"></textarea>
                            </div>
                        </div>
                        <div class="col-12">
                            <div>
                                <div class="row mb-4 align-items-center">
                                    <div class="col-sm-12">
                                        <div class="question-box">
                                            <div
                                                class="d-flex align-items-center justify-content-between mb-3 flex-wrap">
                                                <p class="label-title">
                                                    Question - 1
                                                </p>
                                            </div>
                                            <div class="col-lg-12 col-sm-12">
                                                <div class="form-group mb-4">
                                                    <label>{{QuestionConstant.QUESTION}}<span
                                                            class="form-control-danger">*</span></label>
                                                    <textarea type="text" class="form-control
                                                    form-control-lg" required autocomplete="off"
                                                        formControlName="questionText" placeholder="Enter Question"
                                                        maxlength="500" (keydown)="CommonService.space($event)"
                                                        oninput="this.value = this.value.replace(/^\s+/g, '')"></textarea>
                                                </div>
                                            </div>
                                            <div formArrayName="questionOptions">
                                                <div class="create-box mb-3">
                                                    <div class="row mb-4 align-items-center"
                                                        *ngFor="let option of questionOptions?.controls; let i = index"
                                                        [formGroupName]="i">
                                                        <div class="col-sm-1 col-2">
                                                            <div class="form-group">
                                                                <label></label>
                                                            </div>
                                                            <div class="form-group">
                                                                <div class="form-check" *ngIf="showMultiSelect">
                                                                    <input formControlName="isCorrectAnswer"
                                                                        class="form-check-input checkbox-square"
                                                                        type="checkbox" name="radAnswer + i"
                                                                        id="{{ 'flexRadioDefault2' + i }}">
                                                                </div>
                                                                <div class="form-check" *ngIf="showRadio">
                                                                    <input formControlName="isCorrectAnswer"
                                                                        class="form-check-input checkbox-round"
                                                                        type="checkbox" name="radAnswer" value=""
                                                                        id="{{ 'flexRadioDefault1' + i }}">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-9 col-sm-11 col-10">
                                                            <div class="form-group">
                                                                <label>Option {{i+1}}<span
                                                                        class="form-control-danger">*</span></label>
                                                            </div>
                                                            <div class="form-group position-relative">
                                                                <input formControlName="optionText" type="text"
                                                                    class="form-control"
                                                                    (keydown)="CommonService.space($event)" required />
                                                            </div>
                                                        </div>
                                                        <div class="row text-center" *ngIf="CheckCorrect(i) ">
                                                            <div class="col-sm-2 col-2">
                                                            </div>
                                                            <div class="col-sm-7 col-7"
                                                                style="color: green; margin-top: 1%;">
                                                                Correct answer
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div formArrayName="multiQuestions">
                                <div class="row mb-4 align-items-center"
                                    *ngFor="let question of getMultiQuestions(questionEditForm); let i = index"
                                    [formGroupName]="i">
                                    <div class="col-sm-12">
                                        <div class="question-box">
                                            <div
                                                class="d-flex align-items-center justify-content-between mb-3 flex-wrap">
                                                <p class="label-title">
                                                    Question - {{i+2}}
                                                </p>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="form-group mb-4">
                                                        <label>Question<span
                                                                class="form-control-danger">*</span></label>
                                                        <textarea type="text" class="form-control
                                                                form-control-lg" required autocomplete="off"
                                                            formControlName="multiQuestionText"
                                                            placeholder="Enter Question" maxlength="500"
                                                            (keydown)="CommonService.space($event)"
                                                            oninput="this.value = this.value.replace(/^\s+/g, '')"
                                                            id="{{ 'MultiQuestion' + i }}"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div formArrayName="multiOptions">

                                                <div class="row mb-2 align-items-center"
                                                    *ngFor="let option of getMultiOptions(question); let j = index"
                                                    [formGroupName]="j">
                                                    <div class="row mb-3 align-items-center">
                                                        <div class="col-sm-1 col-2">
                                                            <div class="form-group">
                                                                <label></label>
                                                            </div>
                                                            <div class="form-group">
                                                                <div class="form-check" *ngIf="showRadio">
                                                                    <input formControlName="isCorrectAnswer"
                                                                        class="form-check-input checkbox-round"
                                                                        type="checkbox" name="radAnswer + i"
                                                                        id="{{ 'flexRadioDefault1' + i }}">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-9 col-sm-11 col-10">
                                                            <div class="form-group">
                                                                <div class="form-group">
                                                                    <label>Option {{j+1}}<span
                                                                            class="form-control-danger">*</span></label>
                                                                </div>
                                                            </div>
                                                            <div class="form-group position-relative">
                                                                <input formControlName="multiOptionText" type="text"
                                                                    class="form-control"
                                                                    id="{{ 'optionText' + i +'_'+j }}"
                                                                    oninput="this.value = this.value.replace(/^\s+/g, '')"
                                                                    autocomplete="off" />
                                                            </div>
                                                        </div>
                                                        <div class="row text-center" *ngIf="CheckParagraphCorrect(i,j)">
                                                            <div class="col-sm-2 col-2">
                                                            </div>
                                                            <div class="col-sm-7 col-7"
                                                                style="color: green; margin-top: 1%;">
                                                                Correct answer
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="modal-footer justify-content-center border-0 px-2 py-0 mt-4">
                                <button type="button" class="btn btn-border common-button mx-2"
                                    (click)="onCancel()">{{CommonConstant.CANCEL}}</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>